import React from "react";
import Icon from "@ant-design/icons";


const StaffSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M45.82,20.15c0-8-6.51-14.5-14.5-14.5-3.31,0-6.45,1.11-9,3.14-1.31-.98-2.93-1.57-4.69-1.57-4.34,0-7.87,3.55-7.87,7.92,0,3.43,2.19,6.36,5.23,7.45-6.52,1.47-11.52,8.26-11.59,16.4,0,.69.55,1.25,1.24,1.26.74,0,1.25-.55,1.26-1.24.06-7.84,5.33-14.23,11.73-14.23s11.66,6.38,11.73,14.23c0,.69.56,1.24,1.25,1.24h.01c.69,0,1.25-.57,1.24-1.26-.01-1.5-.21-2.95-.54-4.34,8,0,14.5-6.51,14.5-14.5ZM12.25,15.14c0-2.99,2.41-5.42,5.37-5.42s5.37,2.43,5.37,5.42-2.41,5.42-5.37,5.42-5.37-2.43-5.37-5.42ZM31.32,32.15c-.27,0-.53-.04-.79-.05-1.91-4.86-5.71-8.48-10.26-9.51,3.04-1.09,5.23-4.02,5.23-7.45,0-1.69-.53-3.25-1.43-4.54,2.08-1.58,4.59-2.45,7.25-2.45,6.62,0,12,5.38,12,12s-5.38,12-12,12Z" />
        <path d="M38.07,22.66l-5.62-3.41v-8.17c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v8.88c0,.44.23.84.6,1.07l6.22,3.78c.2.12.43.18.65.18.42,0,.83-.21,1.07-.6.36-.59.17-1.36-.42-1.72Z" />
    </svg>
);

const StaffIcon = ({ className }) => (
    <Icon component={ StaffSvg } className={ className } />
);

export default StaffIcon;
